import { Link } from "react-router-dom";
import type { MovieItem } from "@/mocks/movies";

export default function MovieCard({ movie }: { movie: MovieItem }) {
  const path = `/movies/detail/${movie.id}`;

  return (
    <article className="group">
      <Link to={path} className="block cursor-pointer" aria-label={movie.title}>
        <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg bg-secondary-900">
          <img
            src={movie.poster}
            alt={movie.title}
            title={`${movie.title} - 色花堂影视推荐`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute right-2 top-2 flex items-center gap-1 rounded-full bg-primary-500 px-2 py-1 text-xs font-bold text-background-50">
            <i className="ri-star-fill text-xs" aria-hidden="true"></i>
            {movie.rating.toFixed(1)}
          </span>
          <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-secondary-950/90 to-transparent p-3 pt-8">
            <span className="text-xs text-background-200">{movie.region} · {movie.year}</span>
          </div>
        </div>
      </Link>
      <h3 className="mt-3 font-heading text-sm font-bold text-foreground-950">
        <Link to={path} className="line-clamp-1 transition-colors hover:text-primary-700 cursor-pointer">
          {movie.title}
        </Link>
      </h3>
      <p className="mt-1 line-clamp-1 text-xs text-foreground-500">{movie.genre.join(" / ")}</p>
    </article>
  );
}